var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { MixpanelService } from './../../../mixpanel/mixpanel.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { AlgoliaService } from './../algolia.service';
import { Component, ContentChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
var AlgoliaSearchComponent = (function () {
    function AlgoliaSearchComponent(algolia, mixpanelService) {
        this.algolia = algolia;
        this.mixpanelService = mixpanelService;
        this.onKeyEnter = new EventEmitter();
        this.nbrResults = 1;
        this.terms = new Subject();
        this.searchString = '';
        this.selectedIndex = 0;
        this.pages = [];
        this.pageOffset = 0;
        this.nbPages = 7;
        this.maxResults = 1000;
        this.timer = null;
    }
    AlgoliaSearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (typeof this.params.page === "undefined") {
            this.params.page = 0;
        }
        if (typeof this.params.hitsPerPage === "undefined") {
            this.params.hitsPerPage = 4;
        }
        this.obsResults = this.terms.switchMap(function (term) {
            if (term)
                return _this.algolia.search(term, _this.index, _this.params).map(function (res) {
                    _this.nbrResults = res['nbHits'];
                    return res['hits'];
                });
            else {
                _this.nbrResults = 0;
                return Observable.of([]);
            }
        });
        this.selectedIndex = 0;
        this.obsResults.subscribe(function (res) {
            _this.pageOffset = _this.params.page - Math.floor(_this.nbPages / 2);
            if (_this.pageOffset < 0)
                _this.pageOffset = 0;
            _this.pages = Array(_this.nbPages).fill(0).map(function (x, i) { return i + _this.pageOffset; });
            _this.results = res;
            if (_this.results.length) {
                _this.results[_this.selectedIndex].selected = true;
                _this.results = _this.results.map(function (result, index) {
                    result.index = index;
                    return result;
                });
            }
        });
    };
    AlgoliaSearchComponent.prototype.track = function (eventName, itemIndex) {
        var seconds = new Date().getTime();
        seconds = Math.round((seconds - this.timer) / 1000);
        this.timer = null;
        var properties = {
            'actual_page': this.params.page * 1 + 1,
            'item_index': itemIndex,
            'current_search': this.searchString,
            'search_length': this.searchString.length,
            'search_time': seconds
        };
        console.log("properties : " + JSON.stringify(properties));
        this.mixpanelService.api.track(eventName, properties);
    };
    AlgoliaSearchComponent.prototype.reset = function () {
        this.timer = null;
        this.searchString = "";
        this.nbrResults = 0;
        this.search();
    };
    AlgoliaSearchComponent.prototype.ngOnDestroy = function () {
        this.terms.unsubscribe();
    };
    AlgoliaSearchComponent.prototype.navigate = function (event) {
        if (event === void 0) { event = null; }
        if (event != null) {
            switch (event.keyCode) {
                case 13://enter
                    if (this.results && this.results.length)
                        this.onKeyEnter.emit(this.results[this.selectedIndex]);
                    break;
                case 40://down 
                    if (this.results.length > this.selectedIndex + 1) {
                        this.results[this.selectedIndex].selected = false;
                        this.selectedIndex++;
                        this.results[this.selectedIndex].selected = true;
                    }
                    else if (this.results.length && this.params.page * this.params.hitsPerPage < this.nbrResults - this.params.hitsPerPage) {
                        this.params.page++;
                        this.selectedIndex = 0;
                        this.search();
                    }
                    break;
                case 38://up
                    if (this.selectedIndex > 0) {
                        this.results[this.selectedIndex].selected = false;
                        this.selectedIndex--;
                        this.results[this.selectedIndex].selected = true;
                    }
                    else if (this.params.page > 0) {
                        this.params.page--;
                        this.selectedIndex = this.params.hitsPerPage - 1;
                        this.search();
                    }
                    return false;
            }
        }
    };
    AlgoliaSearchComponent.prototype.search = function (event) {
        if (event === void 0) { event = null; }
        if (event != null) {
            switch (event.keyCode) {
                case 13:
                case 40:
                case 38:
                    return false;
                default:
                    this.params.page = 0;
                    this.selectedIndex = 0;
                    this.search();
            }
        }
        else {
            this.terms.next(this.searchString);
            if (this.searchString.length > 0 && this.timer == null)
                this.timer = new Date().getTime();
        }
    };
    AlgoliaSearchComponent.prototype.loadPage = function (page) {
        console.log(page);
        this.params.page = Math.floor(page);
        this.search();
    };
    AlgoliaSearchComponent.prototype.getMaxPage = function () {
        var maxPage = Math.floor(this.maxResults / this.params.hitsPerPage) - 1;
        var maxResult = Math.floor(this.nbrResults / this.params.hitsPerPage - 1) + 1;
        return maxPage < maxResult ? maxPage : maxResult;
    };
    __decorate([
        ContentChild('algoliaResults'),
        __metadata("design:type", TemplateRef)
    ], AlgoliaSearchComponent.prototype, "itemTemplate", void 0);
    __decorate([
        ContentChild('algoliaFooter'),
        __metadata("design:type", TemplateRef)
    ], AlgoliaSearchComponent.prototype, "algoliaFooter", void 0);
    __decorate([
        ContentChild('algoliaHeader'),
        __metadata("design:type", TemplateRef)
    ], AlgoliaSearchComponent.prototype, "algoliaHeader", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], AlgoliaSearchComponent.prototype, "index", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], AlgoliaSearchComponent.prototype, "params", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], AlgoliaSearchComponent.prototype, "onKeyEnter", void 0);
    AlgoliaSearchComponent = __decorate([
        Component({
            selector: 'pt-algolia-search',
            templateUrl: './algolia-search.component.html'
        }),
        __metadata("design:paramtypes", [AlgoliaService,
            MixpanelService])
    ], AlgoliaSearchComponent);
    return AlgoliaSearchComponent;
}());
export { AlgoliaSearchComponent };
//# sourceMappingURL=algolia-search.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/algolia/algolia-search/algolia-search.component.js
// module id = 253
// module chunks = 0